import styled, { CSSProperties, css } from 'styled-components'
import { OVERLAYS_Z_INDEX } from '../constants'

import { ReactComponent as SelectionCornerIconTopLeft } from '@sketch/icons/inspector/top_left'
import { ReactComponent as SelectionCornerIconTopRight } from '@sketch/icons/inspector/top_right'
import { ReactComponent as SelectionCornerIconBottomLeft } from '@sketch/icons/inspector/bottom_left'
import { ReactComponent as SelectionCornerIconBottomRight } from '@sketch/icons/inspector/bottom_right'

type SelectionRectangleContainerProps = {
  $width: number
  $height: number
  $x: number
  $y: number
}
export const SelectionRectangleContainer = styled.div.attrs(
  ({ $x, $y, $width, $height }: SelectionRectangleContainerProps) => {
    const style: CSSProperties = {
      transform: `translate(${$x}px, ${$y}px)`,
      width: `${$width}px`,
      height: `${$height}px`,
    }
    return { style }
  }
)<SelectionRectangleContainerProps>`
  position: absolute;
  z-index: ${OVERLAYS_Z_INDEX.SELECTED_ELEMENT_RECTANGLE};
`

const CORNER_PADDING = 7
const selectionRectangleEdgeLineCss = css`
  background-color: ${({ theme }) => `${theme.colors.sketch.A}`};
  position: absolute;
`
export const SelectionRectangleTopEdgeLine = styled.div`
  ${selectionRectangleEdgeLineCss}
  height: 1px;
  top: -0.5px;
  left: ${CORNER_PADDING}px;
  right: ${CORNER_PADDING}px;
`

export const SelectionRectangleBottomEdgeLine = styled.div`
  ${selectionRectangleEdgeLineCss}
  height: 1px;
  bottom: -0.5px;
  left: ${CORNER_PADDING}px;
  right: ${CORNER_PADDING}px;
`
export const SelectionRectangleLeftEdgeLine = styled.div`
  ${selectionRectangleEdgeLineCss}
  width: 1px;
  left: -0.5px;
  top: ${CORNER_PADDING}px;
  bottom: ${CORNER_PADDING}px;
`
export const SelectionRectangleRightEdgeLine = styled.div`
  ${selectionRectangleEdgeLineCss}
  width: 1px;
  right: -0.5px;
  top: ${CORNER_PADDING}px;
  bottom: ${CORNER_PADDING}px;
`

export const selectionCornerIconCss = css`
  color: ${({ theme }) => theme.colors.sketch.A};
`

export const TopLeftCornerIcon = styled(SelectionCornerIconTopLeft)`
  ${selectionCornerIconCss}
`

export const TopRightCornerIcon = styled(SelectionCornerIconTopRight)`
  ${selectionCornerIconCss}
`

export const BottomLeftCornerIcon = styled(SelectionCornerIconBottomLeft)`
  ${selectionCornerIconCss}
`

export const BottomRightCornerIcon = styled(SelectionCornerIconBottomRight)`
  ${selectionCornerIconCss}
`
